import React, { useContext, useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
// reactstrap components
import {
    Button,
    Card,
    CardBody,
    CardFooter,
    CardTitle,
    Label,
    FormGroup,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    CustomInput,
    Container,
    Row,
    Col,
    Spinner,
    Modal
} from "reactstrap";

// core components
import LoggedinHeader from "../../components/Headers/LoggedinHeader.js";
import LoggedinNavbar from "../../components/Navbars/LoggedinNavbar.js";
import LoggedinFooter from "../../components/Footers/LoggedinFooter.js";
import { AuthContext } from '../../AuthContext';
import { AxiosContext } from '../../AxiosContext';
import { AnimatePresence, motion } from "framer-motion";
import HomeSkeleton from "../../skeleton-screens/HomeSkeleton";
import ADModal from '../../components/ADModal';

function AdminUnblockvc() {
    const navigate = useNavigate();
    const auth = useContext(AuthContext);
    const { authAxios } = useContext(AxiosContext);

    const [isLoading, setIsLoading] = useState(false);
    const [modalMsg, setModalMsg] = useState('');
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [showSpinner, setShowSpinner] = useState(false);
    const [modalButtonStatus, setModalButtonStatus] = useState('');

    const [dataAds, setDataAds] = useState([]);
    const [username, setUsername] = useState(''),
        onUserNameInput = ({ target: { value } }) => setUsername(value);
    const [userMsg, setUserMsg] = useState([]);
    const [userD, setUserD] = useState('');

    document.documentElement.classList.remove("nav-open");
    React.useEffect(() => {
        document.body.classList.add("adminunblockvc-page");
        return function cleanup() {
            document.body.classList.remove("adminunblockvc-page");
        };
    });

    const renderSpinner = () => {
        if (showSpinner) {
            return (
                <Modal isOpen={showSpinner} centered={true} className="spinnerModal">
                    <div className="modal-body">
                        <Spinner color="primary">
                            Loading...
                        </Spinner>
                    </div>
                </Modal>

            );
        }
    };
    const showModal = (msg, status) => {
        setModalMsg(msg);
        setIsModalVisible(!isModalVisible);
        setModalButtonStatus(status);
    };

    const handleModal = () => {
        if (modalButtonStatus == "success") {
            showModal('','');
            navigate('/admin');
        } else {
            showModal('','');
        }
    }

    const renderOkButton = () => {
        return (
            <Button
                className="btn-round"
                color="primary"
                type="button"
                onClick={() => handleModal()}
            >
                <span style={{ color: '#0b1011', textTransform: 'none' }}>&nbsp;&nbsp; ok &nbsp;&nbsp;</span>
            </Button>
        );
    };

    const unblockUser = async () => {
        try {
            if (userD != '') {
                setShowSpinner(true);
                let url = '/adminunblocklaunch';
                let data = {
                    data: {
                        user: userD
                    }
                };
                const response = await authAxios.post(url, data);
                let result = response.data;
                if (typeof response.data.error === 'undefined' && typeof response.data.data !== 'undefined') {
                    if (result.data == 'success') {
                        setShowSpinner(false);
                        showModal("Updated user successfully-  " + username, "success");
                    } else {
                        setShowSpinner(false);
                        throw "Server error. Please retry";
                    }
                } else {
                    setShowSpinner(false);
                    throw (response.data.error === undefined) ? 'Server error. Please retry' : response.data.error;
                }

                setShowSpinner(false);
            } else {
                showModal("Please verify username", "fail");
            }

        } catch (error) {
            if (typeof error.message === 'undefined') {
                showModal(error, "fail");
            } else {
                showModal(error.message, "fail");
            }
            setShowSpinner(false);
        }
    }

    const verifyUser = async () => {
        try {
            
            if (username != '') {
                setShowSpinner(true);
                let url = '/admindesign';
                let data = {
                    data: {
                        type: 'verifyuser',
                        user: username
                    }
                };
                
                const response = await authAxios.post(url, data);
                let result = response.data;
                if (typeof response.data.error === 'undefined' && typeof response.data.data !== 'undefined') {
                    setUserMsg('User exists. Name is: ' + result.data.name);
                    setUserD(result.data.userid);
                } else {
                    setShowSpinner(false);
                    throw (response.data.error === undefined) ? 'Server error. Please retry' : response.data.error;
                }

                setShowSpinner(false);
            } else {
                showModal("Please enter username", "fail");
            }

        } catch (error) {
            if (typeof error.message === 'undefined') {
                showModal(error, "fail");
            } else {
                showModal(error.message, "fail");
            }
            setShowSpinner(false);
        }
    }

   

    return (
        <>
            <LoggedinHeader />
            <LoggedinNavbar />
            <AnimatePresence>
                <div className="main">
                    <div className="text-center">
                        {isLoading && (
                            <Container>
                                <HomeSkeleton exit={{ opacity: 0 }} />
                            </Container>
                        )}
                        <Container>
                            {!isLoading && (
                                <Row>
                                    <Col className="ml-auto mr-auto">
                                        <div className="AdminDesignContainer">
                                            <div className="AdminDesignHeader">
                                                <h3>Unblock and allow user access to launch the VistaCreate editor for this month</h3>
                                            </div>
                                            <div className="AdminDesignText">
                                                <p style={{ marginTop: '20px' }}>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;<i className="nc-icon nc-check-2"></i>&nbsp;&nbsp;Enter the userid (email or phone) for whom you want to unblock and allow access to launch the VistaCreate editor
                                                </p>
                                                <p style={{ marginTop: '20px' }}>
                                                    &nbsp;&nbsp;&nbsp;&nbsp;<i className="nc-icon nc-check-2"></i>&nbsp;&nbsp;Verify user or you won't be able to proceed
                                                </p>
                                            </div>
                                            <div className="AdminDesignForm">
                                                <Card className="card-register" style={{ minHeight: "unset" }}>
                                                    <Form className="discount-form">
                                                        <div className="AdminDesignForm">
                                                            <div style={{ paddingTop: '10px' }}>
                                                                <InputGroup className="form-group-with-border">
                                                                    <InputGroupAddon addonType="prepend">
                                                                        <InputGroupText>
                                                                            <i className="nc-icon nc-email-85" />
                                                                        </InputGroupText>
                                                                    </InputGroupAddon>
                                                                    <Input
                                                                        placeholder="Enter User Id"
                                                                        type="text"
                                                                        value={username}
                                                                        onChange={onUserNameInput}
                                                                    />
                                                                </InputGroup>
                                                            </div>
                                                            <div style={{ paddingLeft: '10px' }}>
                                                                <Button
                                                                    className="btn-round"
                                                                    color="primary"
                                                                    type="button"
                                                                    onClick={() => verifyUser()}
                                                                >
                                                                    <span style={{ color: '#0b1011', textTransform: 'none' }}>&nbsp;Verify User&nbsp;</span>
                                                                </Button>
                                                            </div>

                                                        </div>
                                                    </Form>
                                                    <div style={{ paddingTop: '10px', color: '#44c47d' }}>
                                                        {userMsg}
                                                    </div>
                                                </Card>
                                            </div>
                                            <div className="AdminDesignSubmit">
                                                <Button
                                                    className="btn-round"
                                                    color="primary"
                                                    type="button"
                                                    onClick={() => unblockUser()}
                                                >
                                                    <span style={{ color: '#0b1011', textTransform: 'none' }}>&nbsp;Unblock&nbsp;</span>
                                                </Button>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>

                            )}
                        </Container>
                    </div>
                    <ADModal
                        isVisible={isModalVisible}
                        msg={modalMsg}
                        children={renderOkButton()}
                    />
                    {renderSpinner()}

                </div>
            </AnimatePresence>
            <LoggedinFooter />

        </>
    );
}

export default AdminUnblockvc;
